import { render, staticRenderFns } from "./PolaroidPhotoAlbum.vue?vue&type=template&id=7117a4cc&scoped=true&"
import script from "./PolaroidPhotoAlbum.vue?vue&type=script&lang=ts&"
export * from "./PolaroidPhotoAlbum.vue?vue&type=script&lang=ts&"
import style0 from "./PolaroidPhotoAlbum.vue?vue&type=style&index=0&id=7117a4cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117a4cc",
  null
  
)

export default component.exports